import { Injectable } from '@angular/core';
import { JssContextService } from '../../jss-context.service';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

interface IAntiForgeryToken {
  name: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class AntiForgeryTokenService implements HttpInterceptor {
  private antiForgeryToken: IAntiForgeryToken;

  constructor(jssContextService: JssContextService) {
    jssContextService.state.subscribe(result => {
      if (
        result &&
        result.sitecore &&
        result.sitecore.context &&
        result.sitecore.context.VerificationToken
      ) {
        this.antiForgeryToken = result.sitecore.context
          .VerificationToken as IAntiForgeryToken;
      } else {
        this.antiForgeryToken = null;
      }
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      (req.method === 'POST' || req.method === 'PUT') &&
      this.antiForgeryToken
    ) {
      const newHeaders = req.headers.set(
        this.antiForgeryToken.name,
        this.antiForgeryToken.value
      );
      req = req.clone({ headers: newHeaders });
    }

    return next.handle(req);
  }
}
